function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#db8d27;}.b{fill:#31a3b4;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M105.225,70.616a9.756,9.756,0,1,0,9.756,9.756,9.756,9.756,0,0,0-9.756-9.756m0,14.179a4.424,4.424,0,1,1,4.424-4.424,4.424,4.424,0,0,1-4.424,4.424",
  transform: "translate(-82.478 -60.861)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M14.5,26.75H11V5.694a2.974,2.974,0,0,0-5.948,0V29.012a2.971,2.971,0,0,0,2.436,2.92,2.61,2.61,0,0,0,.531.054H14.5a2.618,2.618,0,1,0,0-5.237",
  transform: "translate(-5.05 -2.72)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M262.249,87.719a9.755,9.755,0,1,0-13.38,0l-.036.03a9.278,9.278,0,0,0,1.729,1.25,9.688,9.688,0,0,0,5,1.39,4.424,4.424,0,1,1-3.424,7.224c-.009-.013-.121-.18-.156-.231l-4.649,2.617a6.24,6.24,0,0,0,.435.678,9.751,9.751,0,1,0,14.482-12.954m-11.111-7.09a4.424,4.424,0,1,1,4.423,4.423,4.424,4.424,0,0,1-4.423-4.423",
  transform: "translate(-211.214 -61.07)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M412.961,70.608h0a2.664,2.664,0,0,0-2.271,1.274,9.756,9.756,0,1,0,0,16.962,2.664,2.664,0,0,0,4.937-1.39V73.274a2.667,2.667,0,0,0-2.666-2.666m-7.09,14.179a4.424,4.424,0,1,1,4.424-4.424,4.424,4.424,0,0,1-4.424,4.424",
  transform: "translate(-339.922 -60.852)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M259.933,249.622a2.673,2.673,0,1,1-2.673-2.673,2.673,2.673,0,0,1,2.673,2.673",
  transform: "translate(-218.733 -211.858)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M541.434,72.458A1.846,1.846,0,1,1,543.28,74.3a1.846,1.846,0,0,1-1.846-1.846m3.272,0a1.427,1.427,0,1,0-1.427,1.459,1.451,1.451,0,0,0,1.427-1.459m-1.849.179v.729a.168.168,0,0,1-.336,0V71.535c0-.076.036-.107.117-.107h.673c.51,0,.77.148.77.607a.535.535,0,0,1-.526.586l.453.693a.294.294,0,0,1,.052.128c0,.056-.1.086-.19.086a.207.207,0,0,1-.2-.112l-.483-.78Zm.387-.306c.26,0,.5-.021.5-.321,0-.255-.249-.276-.469-.276h-.417v.6Z",
  transform: "translate(-464.365 -60.857)"
});

var SvgLogaLogo = function SvgLogaLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80.76 43.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogaLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loga_logo.1dba9d5e.svg";
export { ForwardRef as ReactComponent };